export type TypelizerRefinement<TBase, TConstraints> = {
  [K in keyof TBase]: K extends keyof TConstraints
    ? TConstraints[K] extends object
      ? TBase[K] extends object
        ? TypelizerRefinement<TBase[K], TConstraints[K]>
        : TConstraints[K]
      : TConstraints[K]
    : TBase[K]
} & {
  [K in Exclude<keyof TConstraints, keyof TBase>]: never
}
export function typedKeys<T extends Record<keyof any, any>>(
  obj: T,
): Array<keyof T> {
  return Object.keys(obj) as Array<keyof T>
}

export function typedEntries<T extends Record<keyof any, any>>(
  obj: T,
): Array<[keyof T, T[keyof T]]> {
  return Object.entries(obj) as Array<[keyof T, T[keyof T]]>
}

export function typedValues<T extends Record<keyof any, any>>(
  obj: T,
): Array<T[keyof T]> {
  return Object.values(obj) as Array<T[keyof T]>
}
